/*
 * @Desc: 
 * @Author: lc
 * @Date: 2023-03-06 08:13:21
 * @LastEditors: lc
 * @LastEditTime: 2023-03-06 08:59:20
 */
import axios from '.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const qrcodes = {
    // 列表
    list (params) {
        return axios.get(api + 'qrcodes/list', { params: params })
    },
    // 添加
    create (params) {
        return axios.post(api + 'qrcodes/create', qs.stringify(params))
    },
    // 下载
    download (params) {
        return axios.post(api + 'qrcodes/download', qs.stringify(params))
    },
}


// 导出接口
export default qrcodes
